"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateToExample = void 0;
const json_1 = require("@stoplight/json");
const pickBy = require("lodash.pickby");
const context_1 = require("../../context");
const guards_1 = require("../../guards");
const resolver_1 = require("../../oas/resolver");
exports.translateToExample = (0, context_1.withContext)(function ([key, example]) {
    const resolvedExample = this.maybeResolveLocalRef(example);
    if (!(0, json_1.isPlainObject)(resolvedExample))
        return;
    const actualKey = this.context === 'service' ? (0, resolver_1.getSharedKey)(resolvedExample) : key;
    return {
        id: this.generateId(`example-${this.parentId}-${actualKey}`),
        key,
        ...(typeof resolvedExample.externalValue === 'string'
            ? { externalValue: resolvedExample.externalValue }
            : { value: resolvedExample.value }),
        ...pickBy({
            summary: resolvedExample.summary,
            description: resolvedExample.description,
        }, guards_1.isString),
    };
});
//# sourceMappingURL=examples.js.map